<form [formGroup]="form" (ngSubmit)="onSubmit()">
    <app-ibase-cru-modal-content
        [showDefaultFormFooter]="true"
        createButtonLabel="Upload file(s)"
        [contentClasses]="['floatingLabelContainer']"
    >
        <p-fileupload
            name="file"
            [multiple]="true"
            [maxFileSize]="FileUtils.MAX_FILE_SIZE"
            mode="advanced"
            method="put"
            chooseLabel="Select file(s)"
            [customUpload]="customUploadDummy"
            [showUploadButton]="false"
            [showCancelButton]="false"
        >
            <ng-template #empty>
                <div style="text-align: center">Drag and drop file(s) to here to upload.</div>
            </ng-template>
            <ng-template #content>
                <ul *ngIf="_files.length">
                    <li *ngFor="let file of _files">{{ file.name }} - {{ file.size }} bytes</li>
                </ul>
            </ng-template>
        </p-fileupload>
    </app-ibase-cru-modal-content>
</form>
